import {
    Button,
    ButtonVariant,
    ColorSchemes,
    componentStyles,
    HorizontalStack,
    VerticalStackStretch,
} from "@mallardbay/lib-react-components"
import React from "react"

import { useAuth } from "~utils/auth-hooks"
import Divider from "~components/shared/todo-lib-react-components/divider"
import ContinueAsGuestForm from "~components/pages/listing/checkout/continue-as-guest-form/continue-as-guest-form"
import COPY from "~config/copy-constants"

interface Props {
    readonly onGuestLoginSuccess?: () => void
    readonly authZeroReturnTo?: string
    readonly isSingleColumn?: boolean
}

export default function SignInOrContinueAsGuestForm({
    onGuestLoginSuccess,
    authZeroReturnTo,
    isSingleColumn,
}: Props) {
    const styles = useStyles()
    const authButtonConfigs = useAuthButtonConfigs({
        returnTo: authZeroReturnTo,
    })

    return (
        <VerticalStackStretch>
            <HorizontalStack>
                {authButtonConfigs.map(({ label, onClick, variant }) => (
                    <Button
                        key={label}
                        style={styles.authButton}
                        onClick={onClick}
                        colorScheme={ColorSchemes.Brand}
                        variant={variant}
                    >
                        {label}
                    </Button>
                ))}
            </HorizontalStack>
            <Divider />
            <ContinueAsGuestForm
                onSuccess={onGuestLoginSuccess}
                isSingleColumn={isSingleColumn}
            />
        </VerticalStackStretch>
    )
}

function useStyles() {
    return componentStyles({
        authButton: { flex: 1 },
    })
}

function useAuthButtonConfigs({ returnTo }: { returnTo?: string }) {
    const { loginWithRedirect } = useAuth()

    return [
        {
            label: COPY.SIGN_IN,
            onClick: () => loginWithRedirect({ returnTo }),
        },
        {
            label: COPY.SIGN_UP,
            onClick: () => loginWithRedirect({ isSignup: true, returnTo }),
            variant: ButtonVariant.Outline,
        },
    ]
}
